<template>
  <div
    class="owal-storage__container"
  >
    <owal-panel
      class="owal-storage__panel"
      title="Diagnostic Export"
      :bottom-buttons="[
        {
          title: 'Export Local Data',
          identifier: 'save'
        },
        {
          title: 'Logout & Reload Application',
          identifier: 'clear'
        }
      ]"
      @button-click="handleButton"
    >
      Use the buttons below to export a diagnostic file to your browser's downloads folder.
      <!-- <pre
        class="owal-storage__text-contents"
      >
        {{ vuexCacheData }}
      </pre> -->
    </owal-panel>
  </div>
</template>

<script>
import OwalPanel from '@/libraries/owal-ui/panels/OwalPanel'
import FileSaver from 'file-saver'

export default {
  name: 'StorageTool',
  components: {
    OwalPanel,
  },
  data () {
    return {
      downloadURL: undefined,
    }
  },
  computed: {
    vuexCacheData () {
      const data = window.localStorage.getItem('vuex')
      if (data) {
        return `${data}`
      }
      return undefined
    },
  },
  methods: {
    clearStore () {
      return window.localStorage.removeItem('vuex')
    },
    save () {
      const blob = new Blob([this.vuexCacheData], { type: 'text/JSON' })
      FileSaver(blob, `OwalDiagnosticExport${new Date().valueOf()}.json`)
    },
    handleButton (identifier) {
      if (identifier === 'save') {
        this.save()
      } else if (identifier === 'clear') {
        const sure = confirm('Are you sure? You will need to log in again.')
        // console.debug(sure)
        if (sure) {
          this.clearStore()
          this.$store.dispatch('logOut').then(Location.reload(true))
        }
      }
    },
  },
}
</script>

<style scope>

.owal-storage__container {
  height: 100%;
  padding: 3rem;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.owal-storage__panel  {
  max-width: 40rem;
}

.owal-storage__text-contents {
  font-family: monospace;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #475669;
  color: #475669;
  padding: 1rem;
}

</style>
